import * as React from "react";
import type { SVGProps } from "react";
const Drink2PanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="m12.426 4.628 3.953-.879-.277-1.246-4.953 1.1v3.279H6l.933 14.468h10.134L18 6.882h-5.574zm4.02 6.509H7.554l-.192-2.979h9.276z" clipRule="evenodd" /></svg>;
export default Drink2PanelIcon;